var incognitoTest, polyfillStore, tracky;

tracky = require('../../../core/frontend/groupon_modules/trackEvent');


/*
 * In-memory mock for local / sessionStorage
 * It is not persistent across pages.
 */

polyfillStore = function() {
  Storage.prototype._data = {};
  Storage.prototype.setItem = function(id, val) {
    return this._data[id] = String(val);
  };
  Storage.prototype.getItem = function(id) {
    if (this._data.hasOwnProperty(id)) {
      return this._data[id];
    } else {
      return null;
    }
  };
  Storage.prototype.removeItem = function(id) {
    return delete this._data[id];
  };
  Storage.prototype.clear = function() {
    return this._data = {};
  };
};


/*
 * Tries to use the sessionStorage setter, which fails in Safari incognito
 *
 * @param {String} env - SLS environment (desktop, touch, M16) to pass to tracky event
 */

incognitoTest = function(env) {
  var ref, ref1;
  if (env == null) {
    env = 'desktop';
  }
  try {
    if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
      sessionStorage.setItem('incognitotest', 'test');
    }
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref = Groupon.PageFlags) != null) {
        ref.isIncognito = false;
      }
    }
  } catch (error) {
    tracky("ls-likely-incognito-session-" + env);
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref1 = Groupon.PageFlags) != null) {
        ref1.isIncognito = true;
      }
    }
    polyfillStore();
  }
};

module.exports = {
  incognitoTest: incognitoTest,
  polyfillStore: polyfillStore
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL2luY29nbml0by5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvanB2ZXJkZWpvL0dyb3Vwb24vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvaW5jb2duaXRvLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQUEsR0FBUyxPQUFBLENBQVEsbURBQVI7OztBQUVUOzs7OztBQUlBLGFBQUEsR0FBZ0IsU0FBQTtFQUNkLE9BQU8sQ0FBQSxTQUFFLENBQUEsS0FBVCxHQUFpQjtFQUNqQixPQUFPLENBQUEsU0FBRSxDQUFBLE9BQVQsR0FBbUIsU0FBQyxFQUFELEVBQUssR0FBTDtXQUFhLElBQUksQ0FBQyxLQUFNLENBQUEsRUFBQSxDQUFYLEdBQWlCLE1BQUEsQ0FBTyxHQUFQO0VBQTlCO0VBQ25CLE9BQU8sQ0FBQSxTQUFFLENBQUEsT0FBVCxHQUFtQixTQUFDLEVBQUQ7SUFBUSxJQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsY0FBWCxDQUEwQixFQUExQixDQUFIO2FBQXNDLElBQUksQ0FBQyxLQUFNLENBQUEsRUFBQSxFQUFqRDtLQUFBLE1BQUE7YUFBMEQsS0FBMUQ7O0VBQVI7RUFDbkIsT0FBTyxDQUFBLFNBQUUsQ0FBQSxVQUFULEdBQXNCLFNBQUMsRUFBRDtXQUFRLE9BQU8sSUFBSSxDQUFDLEtBQU0sQ0FBQSxFQUFBO0VBQTFCO0VBQ3RCLE9BQU8sQ0FBQSxTQUFFLENBQUEsS0FBVCxHQUFpQixTQUFBO1dBQUcsSUFBSSxDQUFDLEtBQUwsR0FBYTtFQUFoQjtBQUxIOzs7QUFPaEI7Ozs7OztBQUtBLGFBQUEsR0FBZ0IsU0FBQyxHQUFEO0FBQ2QsTUFBQTs7SUFEZSxNQUFNOztBQUNyQjs7TUFDRSxjQUFjLENBQUUsT0FBaEIsQ0FBd0IsZUFBeEIsRUFBeUMsTUFBekM7Ozs7V0FDa0IsQ0FBRSxXQUFwQixHQUFrQzs7S0FGcEM7R0FBQSxhQUFBO0lBSUUsTUFBQSxDQUFPLDhCQUFBLEdBQWdDLEdBQXZDOzs7WUFDa0IsQ0FBRSxXQUFwQixHQUFrQzs7O0lBQ2xDLGFBQUEsQ0FBQSxFQU5GOztBQURjOztBQVVoQixNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNmLGVBQUEsYUFEZTtFQUVmLGVBQUEsYUFGZSJ9
